import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import {
  listarCentrosDeCostoConOrganizaciones,
  listarCuentasContablesConOrganizaciones,
  listarOrganizacionesDisponiblesParaCeco,
  type ListarCatalogoContableParams,
} from "../services/catalogos-contables-admin-service";

/**
 * Listados PAGINADOS del gestor admin de catálogos contables. Hooks separados
 * de los del wizard (`useCecos`/`useCuentas` en features/catalogos · flat, sin
 * params) para no tocar a los pickers de prorrateo. Las keys extienden
 * qk.cecos / qk.cuentas: los invalidate de las mutations alcanzan a ambas
 * variantes por prefijo.
 */
export const cuentasAdminQueryOptions = (params: ListarCatalogoContableParams = {}) =>
  queryOptions({
    queryKey: [...qk.cuentas, "admin-orgs", params] as const,
    queryFn: () => listarCuentasContablesConOrganizaciones(params),
    placeholderData: keepPreviousData,
  });

/** Listado del gestor de RELACIONES CeCo↔organización (incluye las organizaciones por CeCo). */
export const cecosConOrgsAdminQueryOptions = (params: ListarCatalogoContableParams = {}) =>
  queryOptions({
    queryKey: [...qk.cecos, "admin-orgs", params] as const,
    queryFn: () => listarCentrosDeCostoConOrganizaciones(params),
    placeholderData: keepPreviousData,
  });

/** Organizaciones activas asignables a un CeCo · opciones del multiselect (cambian poco). */
export const organizacionesParaCecoQueryOptions = queryOptions({
  queryKey: [...qk.cecos, "organizaciones-disponibles"] as const,
  queryFn: listarOrganizacionesDisponiblesParaCeco,
  staleTime: 5 * 60_000,
});

export const useCecosConOrgsAdmin = (params: ListarCatalogoContableParams = {}) =>
  useQuery(cecosConOrgsAdminQueryOptions(params));

export const useOrganizacionesParaCeco = () => useQuery(organizacionesParaCecoQueryOptions);

export const useCuentasAdmin = (params: ListarCatalogoContableParams = {}) =>
  useQuery(cuentasAdminQueryOptions(params));
